var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/wallet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.75 17.0625H5.25C2.67 17.0625 0.9375 15.33 0.9375 12.75V9C0.9375 6.69 2.3625 5.01751 4.575 4.74001C4.785 4.71001 5.0175 4.6875 5.25 4.6875H12.75C12.93 4.6875 13.1625 4.695 13.4025 4.7325C15.615 4.9875 17.0625 6.6675 17.0625 9V12.75C17.0625 15.33 15.33 17.0625 12.75 17.0625ZM5.25 5.8125C5.07 5.8125 4.8975 5.82749 4.725 5.84999C3.075 6.05999 2.0625 7.26 2.0625 9V12.75C2.0625 14.685 3.315 15.9375 5.25 15.9375H12.75C14.685 15.9375 15.9375 14.685 15.9375 12.75V9C15.9375 7.245 14.91 6.03751 13.245 5.84251C13.065 5.81251 12.9075 5.8125 12.75 5.8125H5.25Z",
    fill: "#7BCF8C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.64254 5.85751C4.46254 5.85751 4.29754 5.77501 4.18504 5.62501C4.05754 5.45251 4.04254 5.22751 4.14004 5.04001C4.26754 4.78501 4.44753 4.53751 4.68003 4.31251L7.11753 1.8675C8.36253 0.630002 10.3875 0.630002 11.6325 1.8675L12.945 3.19502C13.5 3.74252 13.8375 4.47752 13.875 5.25752C13.8825 5.43002 13.815 5.595 13.6875 5.7075C13.56 5.82 13.3875 5.87252 13.2225 5.84252C13.0725 5.82002 12.915 5.81251 12.75 5.81251H5.25004C5.07004 5.81251 4.89754 5.8275 4.72504 5.85C4.70254 5.8575 4.67254 5.85751 4.64254 5.85751ZM5.89504 4.68751H12.615C12.5175 4.43251 12.36 4.20002 12.15 3.99002L10.83 2.65502C10.0275 1.86002 8.71503 1.86002 7.90503 2.65502L5.89504 4.68751Z",
    fill: "#7BCF8C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.5 12.9375H14.25C13.11 12.9375 12.1875 12.015 12.1875 10.875C12.1875 9.735 13.11 8.8125 14.25 8.8125H16.5C16.8075 8.8125 17.0625 9.0675 17.0625 9.375C17.0625 9.6825 16.8075 9.9375 16.5 9.9375H14.25C13.7325 9.9375 13.3125 10.3575 13.3125 10.875C13.3125 11.3925 13.7325 11.8125 14.25 11.8125H16.5C16.8075 11.8125 17.0625 12.0675 17.0625 12.375C17.0625 12.6825 16.8075 12.9375 16.5 12.9375Z",
    fill: "#7BCF8C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.8106db60b61503d893e0f3f06666e6fa.svg";
export { ForwardRef as ReactComponent };